
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.label string
 * @param responseData.provider string
 * @param responseData.status string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    data.items = items;
    data.totalResults = totalResults;
    return data;
}

const queryGetGeolocation = (posTerminalUuid) => {
    return {
        queryKey: [POS_TERMINALS.ETHERNET_LOCATION.queryKey, posTerminalUuid],
        queryFn: async () => {
            const response = await client.get(replaceParameters(POS_TERMINALS.ETHERNET_LOCATION.url, { posTerminalUuid: posTerminalUuid }));
            return response.data;
        }
    };
};


export default queryGetGeolocation;